import { StoreKit, createDynamicBaseQuery, getSharedStorageUrl, prepareHeaders } from '@nx/state';
import type { RootState as FrameworkRootState } from '@nx/state';
import { QueryStateContext } from '@query/redux/query-state-context';
import { log } from '@query/services/logging';
import { buildCreateApi, coreModule, reactHooksModule } from '@reduxjs/toolkit/query/react';
import { createDispatchHook, createSelectorHook, createStoreHook } from 'react-redux';

import type { QueryEndpointBuilder } from './types';
import { NAME, tagTypes } from './types';

export const customCreateApi = buildCreateApi(
  coreModule(),
  reactHooksModule({
    hooks: {
      useDispatch: createDispatchHook(QueryStateContext),
      useSelector: createSelectorHook(QueryStateContext),
      useStore: createStoreHook(QueryStateContext),
    },
  }),
);

export const baseApi = customCreateApi({
  tagTypes,
  reducerPath: NAME,
  baseQuery: createDynamicBaseQuery(
    (state) => getSharedStorageUrl(state, log.error, 'sharedStorageApiUrl'),
    { prepareHeaders },
    (): FrameworkRootState => {
      const { globalStore } = StoreKit.UNSAFE_getGlobalStoreInstance();
      return globalStore.getState();
    },
  ),
  // explicit builder type so that tag types are inferred where baseApi is extended
  endpoints: (_: QueryEndpointBuilder) => ({}),
});
